import React, {Component} from 'react'

class Section extends Component {
    render() {
        return (
            <section id={this.props.id ? this.props.id : null}
                     className={this.props.lighter ? "section bg-grey" : "section"}>
                <div className="container">
                    <div className="margin-bottom-70">
                        <div className="row text-center">
                            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                                <h2 className="font-weight-normal">{this.props.title}</h2>
                                <div className="divider-width-50px">
                                    <hr className="bg-black-05"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {this.props.children}
                    </div>
                </div>
            </section>
        )
    }
}

export default Section